"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoClearPlayerCommand = void 0;
const clear_player_action_1 = require("../../actions/clear-player-action");
class AutoClearPlayerCommand {
    constructor(player, playerManager, eventQueue) {
        this.player = player;
        this.playerManager = playerManager;
        this.eventQueue = eventQueue;
    }
    static isCommand(command) {
        return command instanceof AutoClearPlayerCommand;
    }
    executeCommand(_commandHash, _existingDeal, instant) {
        const drawDeckPlayerAction = new clear_player_action_1.ClearPlayerAction(this.playerManager.board, this.player.playerId);
        drawDeckPlayerAction.execute();
        drawDeckPlayerAction.resolve();
        this.eventQueue.enqueue({
            type: "onPlayerCleared",
            instant,
            payload: { player: this.player.clone() },
        });
        return Promise.resolve();
    }
}
exports.AutoClearPlayerCommand = AutoClearPlayerCommand;
